module.exports = __webpack_public_path__ + "img/kz.dd39dd9e.png";